import { render, staticRenderFns } from "./AdditionalQsDialogSaleableItem.vue?vue&type=template&id=2582f08f&scoped=true"
import script from "./AdditionalQsDialogSaleableItem.vue?vue&type=script&lang=js"
export * from "./AdditionalQsDialogSaleableItem.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQsDialogSaleableItem.vue?vue&type=style&index=0&id=2582f08f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582f08f",
  null
  
)

export default component.exports